import type { PropsWithChildren } from "react";
import { AnimatePresence, motion } from "framer-motion";
import XSmall from "../Svg/XSmall";

interface ModalProps extends PropsWithChildren {
  onClick: (show: boolean) => void;
  show?: boolean;
  title?: string;
  padding?: number;
}

export default function Modal({
  children,
  onClick,
  show,
  title,
  padding = 4,
}: ModalProps) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.4, // Increase this number to slow it down
            ease: "easeOut", // This makes the finish feel smoother
          }}
          className={`fixed inset-0 z-50 text-black bg-black/50 app flex flex-col backdrop-blur-xs max-w-2xl translate-z-64`}
        >
          <div
            className="flex flex-grow w-full"
            onClick={() => onClick(false)}
          ></div>
          <motion.div
            initial={{ opacity: 0, y: "200px" }}
            animate={{ opacity: 1, y: "0px" }}
            exit={{ opacity: 0, y: "200px" }}
            transition={{
              duration: 0.3, // Increase this number to slow it down
              ease: "easeOut", // This makes the finish feel smoother
            }}
            className="w-full"
          >
            <div className="flex justify-between border-b border-black/5 items-center px-4 py-3 bg-custom-100 rounded-t-xl">
              <div className="text-fluid-md">{title}</div>
              <XSmall
                onClick={() => onClick(false)}
                className="size-fluid-6 cursor-pointer"
              />
            </div>
            <div
              className={`w-full max-h-[calc(100vh-8rem)] bg-custom-100 p-${padding} text-fluid-base overflow-scroll`}
            >
              <div>{children}</div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
